interface IMedfarBillingCustomCodeItem {
    key: string;
    value: string;
    specialValue?: string;
}

interface IMedfarBillingCustomCodeBoxProps {
    items: Immutable.List<IMedfarBillingCustomCodeItem>;
    onItemRemoveCallback: (item: IMedfarBillingCustomCodeItem) => void;
}

class MedfarBillingCustomCodeBox extends React.Component<IMedfarBillingCustomCodeBoxProps, never> {
    public render(): JSX.Element {
        return (
            <div className="fmp-custom-item-container" style={{ height: "44px", paddingTop: "0px", width: "390px", whiteSpace: "nowrap", overflowX: "hidden" }}>
                {this.props.items.map(item => (
                    <div key={item.key} className="flex-container fmp-custom-item" style={{ paddingTop: "2px" }}>
                        <div className="a"><span onClick={() => this.removeItem(item)} className="glyphicon glyphicon-remove red-text pointer" /></div>
                        <div className="b" style={{ marginLeft: "5px" }}><span>{item.key} - {item.value}</span></div>
                    </div>
                ))}
            </div>
        );
    }

    private removeItem(item: IMedfarBillingCustomCodeItem): void {
        this.props.onItemRemoveCallback(item);
    }
}

export { IMedfarBillingCustomCodeItem, MedfarBillingCustomCodeBox };
